import React from "react";
import styled from "@emotion/styled";
import { Spring, animated } from "react-spring/renderprops";
import { withGesture } from "react-with-gesture";

const SlideContainer = styled.div`
  position: absolute;
  height: 100%;
  top: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform-origin: 50% 50%;
  overflow: visible;
`;

const SlideCard = styled.div`
  position: relative;
  width: 90vw;
  max-width: 600px;
  height: 54vw;
  max-height: 360px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  transform-origin: 50% 50%;
  overflow: visible;
  
  @media (min-width: 640px) {
    width: 80vw;
    height: 48vw;
  }
  
  @media (min-width: 768px) {
    width: 70vw;
    height: 42vw;
  }
  
  @media (min-width: 1024px) {
    width: 600px;
    height: 360px;
  }
`;

function Slide({
  content,
  offsetRadius,
  index,
  animationConfig,
  moveSlide,
  delta,
  down,
  up
}) {
  const offsetFromMiddle = index - offsetRadius;
  const totalPresentables = 2 * offsetRadius + 1;
  // Increased scale for background cards - they will be larger now
  // Original: 1 - Math.abs(offsetFromMiddle / (offsetRadius + 1))
  // Modified to make background cards 85% instead of smaller
  const distanceFactor = offsetFromMiddle === 0 
    ? 1 
    : 0.85 + (0.15 * (1 - Math.abs(offsetFromMiddle) / (offsetRadius + 1)));

  const offsetCardClick = i => {
    console.log(i);
  };

  const translateYoffset =
    50 * (Math.abs(offsetFromMiddle) / (offsetRadius + 1));
  let translateY = -50;

  if (offsetRadius !== 0) {
    if (index === 0) {
      translateY = 0;
    } else if (index === totalPresentables - 1) {
      translateY = -100;
    }
  }

  if (offsetFromMiddle === 0 && down) {
    translateY += delta[1] / (offsetRadius + 1);
    if (translateY > -40) {
      moveSlide(-1);
    }
    if (translateY < -100) {
      moveSlide(1);
    }
  }
  if (offsetFromMiddle > 0) {
    translateY += translateYoffset;
  } else if (offsetFromMiddle < 0) {
    translateY -= translateYoffset;
  }

  // Calculate opacity - reduce for background cards (lower opacity)
  const cardOpacity = offsetFromMiddle === 0 
    ? 1 
    : 0.2 + (0.15 * (1 - Math.abs(offsetFromMiddle) / (offsetRadius + 1)));

  // Add drop shadow to cards - minimal opacity for subtle effect
  const boxShadow = offsetFromMiddle === 0 
    ? '0 20px 40px rgba(0, 0, 0, 0.05), 0 10px 20px rgba(0, 0, 0, 0.04)' 
    : '0 8px 16px rgba(0, 0, 0, 0.03), 0 4px 8px rgba(0, 0, 0, 0.02)';

  return (
    <Spring
      to={{
        transform: `translateX(0%) translateY(${translateY}%) scale(${distanceFactor})`,
        top: `${
          offsetRadius === 0 ? 50 : 50 + (offsetFromMiddle * 50) / offsetRadius
        }%`,
        opacity: cardOpacity
      }}
      config={animationConfig}
    >
      {style => (
        <SlideContainer
          style={{
            ...style,
            zIndex: Math.abs(Math.abs(offsetFromMiddle) - 2)
          }}
        >
          <SlideCard 
            onClick={() => moveSlide(offsetFromMiddle)}
            style={{ boxShadow }}
          >
            {content}
          </SlideCard>
        </SlideContainer>
      )}
    </Spring>
  );
}

export default withGesture()(Slide);
